<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.ALL_INHABITANTS_CUSTOMERS') }}
    </v-card-title>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn @click="getFile">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';
import { ReportsService } from '@/services/reports.service';

export default {
  name: 'CustomersHabitation',

  mixins: [downloadFile],

  methods: {
    getFile() {
      ReportsService.getCustomerHabitationReport()
        .then(response => {
          const filename = this.$t('REPORTS.ALL_INHABITANTS_CUSTOMERS');
          const datetime = new Date().toISOString().slice(0, 10);

          this.downloadFile(response, `${filename} ${datetime}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
